import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useEditorActions, useSelectedId } from '../../store/editorStore.jsx';

const LEVEL_TAGS = { 1: 'h1', 2: 'h2', 3: 'h3', 4: 'h4' };

const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    ['link'],
    ['clean'],
  ],
};
const quillFormats = ['bold', 'italic', 'underline', 'link'];

export function HeadingCanvas({ block }) {
  const selectedId = useSelectedId();
  const { updateAttrs, selectBlock } = useEditorActions();
  const isSelected = selectedId === block.id;
  const level = block.attrs.level || 2;
  const Tag = LEVEL_TAGS[level] || 'h2';
  const [localHtml, setLocalHtml] = useState(block.attrs.html || '');

  useEffect(() => {
    setLocalHtml(block.attrs.html || '');
  }, [block.attrs.html]);

  const handleBlur = () => {
    if (localHtml !== block.attrs.html) {
      updateAttrs(block.id, { html: localHtml });
    }
  };

  if (!isSelected) {
    return (
      <Tag
        className="editor-heading-preview mb-0"
        style={{ cursor: 'text', fontWeight: 700 }}
        onClick={() => selectBlock(block.id)}
        dangerouslySetInnerHTML={{
          __html: block.attrs.html || `<span class="text-muted fw-normal fst-italic">Heading text…</span>`,
        }}
      />
    );
  }

  return (
    <div className="editor-heading-editor" onClick={(e) => e.stopPropagation()}>
      <div className="mb-2">
        {[1, 2, 3, 4].map((l) => (
          <button
            key={l}
            type="button"
            className={`btn btn-sm me-1 ${level === l ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => updateAttrs(block.id, { level: l })}
          >
            H{l}
          </button>
        ))}
      </div>
      <ReactQuill
        theme="snow"
        value={localHtml}
        onChange={setLocalHtml}
        onBlur={handleBlur}
        modules={quillModules}
        formats={quillFormats}
        style={{ backgroundColor: 'white' }}
      />
    </div>
  );
}

export function HeadingInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  const level = block.attrs.level || 2;
  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">Level</label>
        <div className="d-flex gap-1">
          {[1, 2, 3, 4].map((l) => (
            <button
              key={l}
              type="button"
              className={`btn btn-sm ${level === l ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => updateAttrs(block.id, { level: l })}
            >
              H{l}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
